import React, { useEffect, useState } from "react";
import get from "lodash/get";

import StoryCard22 from "../../molecules/story-card22";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import Separator from "../../atoms/separator";
import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";

import "./Row-18-budget.m.css";

function Row18Budget({ collection, index }) {
  const [isMobile, setMobile] = useState(false);
  if (!(collection && collection.items)) return null;
  const budgetEmbed = get(collection, ["associated-metadata", "budget embed"], "");

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  // Get stories from the collection
  const stories = filterStory(collection);
  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);
  const col1StoryCount1 = desktopAdUnitId ? 4 : 6;
  const col1StoryCount2 = isMobile ? 1 : desktopAdUnitId ? 7 : 9;
  const col3StoryCount = isMobile ? 11 : desktopAdUnitId ? 4 : 6;

  if (!stories.length) return null;

  const AdCard = ({ id, mobile }) => {
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
      if (window && window.innerWidth < 767) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    }, []);
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <div styleName="main-wrapper">
      <CollectionTitleHeader collection={collection} index={index} />
      {/* <div className="hide-mobile"> */}
      <div styleName="wrapper">
        <div className="hide-mobile" styleName="col1">
          {stories?.slice(col1StoryCount1, col1StoryCount2).map((item, index) => (
            <div styleName="col-cards" key={item.id}>
              <StoryCard22
                story={item}
                aspectRatio={isMobile ? [1, 1] : [16, 9]}
                imageType={isMobile ? "image1x1" : "image16x9"}
              />
            </div>
          ))}
        </div>
        <div styleName="col2">
          <div styleName={`col2-big-card ${desktopAdUnitId ? "margin" : ""}`}>
            <StoryCard22 story={stories?.[0]} />
          </div>

          <div styleName={`col2-small-cards ${desktopAdUnitId ? "gap" : ""}`}>
            <React.Fragment>
              <div styleName="col-cards budget-embed">
                {budgetEmbed && isMobile ? (
                  <div dangerouslySetInnerHTML={{ __html: budgetEmbed }}></div>
                ) : (
                  <StoryCard22 story={stories[1]} />
                )}
              </div>
              <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} />
              <div styleName="col-cards ">
                {isMobile ? <StoryCard22 story={stories[1]} /> : <StoryCard22 story={stories[2]} />}
              </div>
            </React.Fragment>
          </div>
        </div>
        <div styleName="col3">
          <React.Fragment>
            <div styleName="col-cards budget-embed">
              {budgetEmbed && !isMobile ? (
                <div dangerouslySetInnerHTML={{ __html: budgetEmbed }}></div>
              ) : isMobile ? (
                <StoryCard22 story={stories[2]} />
              ) : (
                <StoryCard22 story={stories[3]} />
              )}
            </div>
          </React.Fragment>
          {stories?.slice(isMobile ? 3 : 4, isMobile ? col3StoryCount - 1 : col3StoryCount).map((item, index) => (
            <React.Fragment key={item.id}>
              {index === 3 ? <AdCard id="div-gpt-ad-1675837369311-1" mobile={mobileAdUnitId2} /> : null}
              <div styleName="col-cards" key={item.id}>
                <StoryCard22 story={item} />
              </div>
              {index === 7 ? <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} /> : null}
            </React.Fragment>
          ))}
          <div styleName="col3-section-3">
            {!isMobile && desktopAdUnitId ? (
              <div styleName="ad-wrapper">
                <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1680156228599-0" desktop={desktopAdUnitId} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {/* </div> */}
      <Separator />
    </div>
  );
}

export default Row18Budget;
